export interface ReasonBreakdown {
  date: string;
  reason: 'user_click' | 'one_click_unsubscribe' | 'bounce' | 'debounce_api' | 'manual_api' | 'upload_csv' | 'fbl' | 'oob';
  source: string;
  count: number;
}

export const ALL_REASONS = ['user_click', 'one_click_unsubscribe', 'bounce', 'debounce_api', 'manual_api', 'upload_csv', 'fbl', 'oob'] as const;

export const REASON_LABELS = {
  user_click: 'User Click',
  one_click_unsubscribe: 'One-Click Unsubscribe',
  bounce: 'Bounce', 
  debounce_api: 'Debounce API',
  manual_api: 'Manual API',
  upload_csv: 'Upload CSV',
  fbl: 'FBL Complaint',
  oob: 'OOB Bounce'
} as const;

export const getActiveReasons = (reasonBreakdown: ReasonBreakdown[]) => {
  return ALL_REASONS.filter(reason => {
    const total = reasonBreakdown.filter(r => r.reason === reason).reduce((sum, r) => sum + r.count, 0);
    return total > 0;
  });
};

export const hasAnyReasonData = (reasonBreakdown: ReasonBreakdown[]) => {
  return ALL_REASONS.some(reason => {
    const total = reasonBreakdown.filter(r => r.reason === reason).reduce((sum, r) => sum + r.count, 0);
    return total > 0;
  });
};